// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1hlie","title":"ClientReferral_title__xK0xp","itemText":"ClientReferral_itemText__5wpig"};